import { Injectable } from '@angular/core';

@Injectable()
export class NavbarService {
    public visible: boolean;
    public forgot: boolean;

    constructor() {
        this.visible = true;
    }

    public hide() { this.visible = false; }

    public show() { this.visible = true; }

    public toggle() { this.visible = !this.visible; }

}
